import style from "../../templates-modal.module.css";

interface TemplateSearchHeaderProps {
  searchTerm: string;
  onSearch: (searchTerm: string) => void;
}

export function TemplateSearchHeader({ searchTerm, onSearch }: TemplateSearchHeaderProps) {
  return (
    <div className={style.header}>
      <div className={style.searchContainer}>
        <input
          type="text"
          value={searchTerm}
          placeholder="Search template"
          autoFocus
          onChange={(e) => onSearch(e.target.value.toLowerCase())}
        />
      </div>
    </div>
  );
}
